import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ebb-portal-dialog-activate-complete',
  templateUrl: './dialog-activate-complete.component.html',
})
export class DialogActivateCompleteComponent {

  constructor(
    public dialogRef: MatDialogRef<any>) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}